import { CustomInputInteface } from '../../core/models/inputs';

interface Props {
  id: string;
  name: string;
  label?: string;
  max?: number;
  placeholder: string;
  input: CustomInputInteface;
  rows?: number;
}

function CustomTextarea({ id, name, label, placeholder, input, max, rows = 8 }: Props) {
  return (
    <div className="input">
      <div className="input__header">
        {!label ? null : (
          <label className="input__label" htmlFor={id}>
            {label}
          </label>
        )}
      </div>
      <div className="input__wrapper">
        <textarea
          id={id}
          name={name}
          value={input.value}
          onChange={input.onChange}
          placeholder={placeholder}
          className="input__field"
          maxLength={max}
          rows={rows}
        />
      </div>
    </div>
  );
}

export default CustomTextarea;
